import React, { useState, useEffect } from "react";
import { getServices } from "../firestoreServices";

const Services = ({ lang }) => {
  const [dbServices, setDbServices] = useState([]);

  // المحتوى الثابت (الاحتياطي)
  const defaultItems = [
    {
      id: 1,
      title: lang === "ar" ? "تسوية المنازعات" : "Dispute Resolution",
      desc:
        lang === "ar"
          ? "تمثيل العملاء أمام جميع المحاكم..."
          : "Representing clients...",
      icon: "🔨",
    },
    // ... (ممكن تحط باقي بياناتك القديمة هنا كـ Fallback)
  ];

  // عناوين السكشن
  const staticTitles = {
    ar: {
      title: "خدماتنا",
      subTitle: "مجالات الخبرة",
      desc: "نقدم حلولاً قانونية متخصصة...",
    },
    en: {
      title: "Our Services",
      subTitle: "Areas of Expertise",
      desc: "We provide specialized legal solutions...",
    },
  };
  const tHeader = staticTitles[lang];

  useEffect(() => {
    getServices().then((data) => {
      if (data.length > 0) setDbServices(data);
    });
  }, []);

  // دمج البيانات (لو الداتا بيز فاضية، اعرض الثابت)
  const itemsToDisplay =
    dbServices.length > 0
      ? dbServices.map((item) => ({
          id: item.id,
          icon: item.icon,
          title: item[lang]?.title || item["en"]?.title,
          desc: item[lang]?.desc || item["en"]?.desc,
        }))
      : defaultItems; // هنا المفروض تحط الـ content.ar.items القديم بتاعك كامل

  const isAr = lang === "ar";

  return (
    <section
      className="services-section"
      id="services"
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="container">
        <div className="section-header center">
          <h2 className="main-heading">{tHeader.title}</h2>
          <div className="heading-line"></div>
          <p className="header-desc">{tHeader.desc}</p>
        </div>

        <div className="services-grid">
          {itemsToDisplay.map((item, index) => (
            <div className="service-card" key={item.id || index}>
              <div className="card-number">0{index + 1}</div>
              <div className="service-icon">{item.icon}</div>
              <h3 className="service-title">{item.title}</h3>
              <p className="service-desc">{item.desc}</p>
              <div className="card-border"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
